var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprite.svg#icon-earth-2';
                    var viewUrl = 'sprite.svg#view-icon-earth-2';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 100 125',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };